export default __webpack_public_path__ + "static/media/5.52fb8aa2.png";